// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__URQVK","success":"Icon_success__gPk04","error":"Icon_error__Xb0rK","warning":"Icon_warning__HDbbC","neutral":"Icon_neutral__tL4c3"};